// Add Clients as they increase - Add Company Logos to assets and import them here
import client1Logo from '../assets/clients/WardsRentalLogo.png'
import heliosLogo from '../assets/common/HCLogoWhite.png'

export const clientsData = [
    {
        id: "wards",
        clientId: "wards",
        name: "Ward's Rental",
        logo: client1Logo,
    },
    {
        id: "helios",
        clientId: "celeste",
        name: "Helios Core",
        logo: heliosLogo,
    },
    {
        id: "scale",
        clientId: "scale",
        name: "Scale Technology Group",
        logo: client1Logo, // TODO: Add Scale logo
    }
]